import { render, staticRenderFns } from "./autodesk.vue?vue&type=template&id=b5915e7c&scoped=true"
import script from "./autodesk.vue?vue&type=script&lang=js"
export * from "./autodesk.vue?vue&type=script&lang=js"
import style0 from "./autodesk.vue?vue&type=style&index=0&id=b5915e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5915e7c",
  null
  
)

export default component.exports